export default __webpack_public_path__ + "static/media/trade-hero.7e6fbf50.svg";